<template>
  <div class="mapboxgl-custom-popup">
    <v-card>
      <v-card-title style="padding-bottom: 8px">
        <h3 id="popup-title" class="body-2 font-weight-bold">{{ this.popup.title }}</h3>
      </v-card-title>

      <v-card-text v-if="this.popup.category != ' ' || this.popup.description || this.popup.description2" class="py-0 pb-3">
        <h4 v-show="this.popup.category" class="caption font-weight-bold primary--text mb-2">{{ this.popup.category }}</h4>
        <p v-show="this.popup.description" class="caption mb-0">{{ this.popup.description }}</p>
        <p v-if="this.popup.description2" class="caption mb-0">{{ this.popup.description2 }}</p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MapPopup',
  computed: {
    ...mapGetters('popup', ['popup']),
  },
};
</script>

<style lang="stylus" scoped>
</style>
